import { ITableCol } from "@data/interfaces/itable.interface";
import {
  LEASE_KIND_COLOR_ENUM,
  LEASE_KIND_ENUM,
  LEASE_STATUS_COLOR_ENUM,
  LEASE_STATUS_ENUM
} from "@modules/private/lease/data/enum/lease.enum";

export const LEASE_KIND_OPTIONS = [
  { value: 'Puro', label: 'Puro' },
  { value: 'Financiado', label: 'Financiado' }
]

export const LEASE_STATUS_OPTIONS = [
  { value: 'Activo', label: 'Activo' },
  { value: 'Liquidado', label: 'Liquidado' },
  { value: 'Cancelado', label: 'Cancelado' }
]

//* Columna de estatus de solo-lectura (sin filtro): en las pestañas el `status` queda
//* forzado por additionalFilters, así que el dropdown de filtro sería engañoso. Se muestra
//* solo para distinguir sub-estados (Pendiente/Aprobado en "Por Originar", Liquidado/Cancelado en "Cerrados").
const LEASE_STATUS_COL_READONLY: ITableCol = { type: 'enum', field: 'status', header: 'Estatus', showFilter: false, dataType: 'enum', enum: LEASE_STATUS_ENUM, enumColor: LEASE_STATUS_COLOR_ENUM, options: LEASE_STATUS_OPTIONS }

//* Columnas base compartidas por las pestañas (sin `status`).
const LEASE_COLUMNS_BASE: ITableCol[] = [
  { type: 'text', field: 'folio', header: 'Arrendamiento', showFilter: true, dataType: 'link', linkField: '_id', rootLink: 'lease' },
  { type: 'text', field: 'client.name', header: 'Cliente', showFilter: true, dataType: 'link', linkField: 'client._id', rootLink: 'customer' },
  { type: 'text', field: 'founder', header: 'Fondeador', showFilter: true },
  //* Leases originados con activo provisional: quotation es null (o assetsNames '') → cae al nombre de la QP
  { type: 'text', field: 'quotation.assetsNames', header: 'Activos', showFilter: true, fallbackFields: ['quotationParameters.assetsNames', 'quotationParameters.provitionalAsset'] },
  { type: 'number', field: 'quotation.termData.term', header: 'Plazo (Meses)', showFilter: true },
  { type: 'number', field: 'quotation.termData.advancedRents.number', header: 'Rentas anticipadas', showFilter: true },
  { type: 'number', field: 'quotation.interestRate', header: 'Tasa de interés', showFilter: true },
  { type: 'enum', field: 'quotation.leaseType', header: 'Tipo de arrendamiento', showFilter: true, dataType: 'enum', enum: LEASE_KIND_ENUM, enumColor: LEASE_KIND_COLOR_ENUM, options: LEASE_KIND_OPTIONS },
]

export const LEASE_COLUMNS: ITableCol[] = [...LEASE_COLUMNS_BASE, { ...LEASE_STATUS_COL_READONLY, showFilter: true, options: LEASE_STATUS_OPTIONS }]

//* Por pestaña (Por Originar / Activos / Cerrados). Activos no muestra status (siempre Activo).
export const LEASE_COLUMNS_POR_ORIGINAR: ITableCol[] = [...LEASE_COLUMNS_BASE, LEASE_STATUS_COL_READONLY]
export const LEASE_COLUMNS_ACTIVOS: ITableCol[] = [...LEASE_COLUMNS_BASE]
export const LEASE_COLUMNS_CERRADOS: ITableCol[] = [...LEASE_COLUMNS_BASE, LEASE_STATUS_COL_READONLY]

export const ACTIONS = [
  // { icon: 'fa-regular fa-pen-to-square', action: 'EDIT', title: 'Editar', color: 'primary' },
  //* Sin `permission`, main-table lo mostraba a todos (la directiva permite por defecto) →
  //* Operaciones/Finanzas/Seller/Legal veían la papelera y recibían 403 (solo Admin tiene delete).
  { icon: 'fa-regular fa-trash-can', action: 'DELETE', title: 'Eliminar', color: 'danger', permission: ['leases', 'delete'] as [string, string] },
]